import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'InlineSvg',
  props: {
    src: {},
    class: {}
  },
  setup(__props: any) {

const props = __props;

const containerRef = ref<HTMLElement | null>(null);

onMounted(async () => {
  if (!props.src.endsWith(".svg")) return;

  try {
    const response = await fetch(props.src);
    const text = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "image/svg+xml");
    const svgEl = doc.querySelector("svg");

    if (svgEl && containerRef.value) {
      if (props.class) {
        svgEl.setAttribute("class", props.class);
      }

      containerRef.value.innerHTML = "";
      containerRef.value.appendChild(svgEl);
    }
  } catch (error) {
    console.error("Ошибка загрузки SVG:", error);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    ref_key: "containerRef",
    ref: containerRef
  }, null, 512))
}
}

})